<template lang="pug">
#planinfo__molecule
  .simple-sidebar__section
    h6.section-title {{ $t('planInfo.consumption') }}
    .section-content
      .info-block.mb-1
        .icon-block
          icon(name='signature')
        .data-block
          span.text.d-block.data-block__title {{ getPlanName }}
          .text.data-block__expiration-date(v-if='!isPostpaid') {{ expirationText }}
          button.btn-link-menu(type='button')
            router-link.plan-details-link(
              :to='{ name: "account.billing.plan" }'
              v-if='isOwner'
            ) {{ $t('planInfo.viewPlanDetails') }}
      .info-block.mb-3(v-if='!isPostpaid')
        .icon-block
          icon(name='paper-plane')
        .data-block.text_sender
          .text {{ remainingSignatures }} {{ $t('planInfo.remainingSignatures') }}
      .button-block(v-if='!isPostpaid')
        router-link.btn.btn-thin(
          :to='{ name: "account.billing.plan", query: { tab: "plans" } }'
          style='width: 100%; font-size: 1rem'
          v-if='isOwner && canUpgradePlan'
        ) {{ $t('planInfo.upgradePlan') }}
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import moment from 'moment';
import PlanName from '@/enums/PlanName';

export default {
  name: 'PlanInfo',
  components: {
    Icon,
  },
  computed: {
    planName() {
      return this.$store.state.subscription.plan.plan.name;
    },
    isPostpaid() {
      return this.$store.getters['subscription/isPostpaid'];
    },
    getPlanName() {
      if (this.isPostpaid) {
        return this.$t('planInfo.postPaid');
      }
      const key = PlanName.getByPlanName(this.planName);
      return this.$t(key);
    },
    canUpgradePlan() {
      if (this.isPostpaid) {
        return false;
      }
      return (
        this.$store.state.subscription.plan.state !== 'cancelled' &&
        this.$store.state.subscription.plan.plan.is_custom === false
      );
    },
    expirationText() {
      const nextRecurrenceAt =
        this.$store.state.subscription.plan.next_recurrence_at;
      const today = moment().startOf('day');
      const formattedDate = moment(nextRecurrenceAt).format('DD/MM/YYYY');
      const nextRecurrenceDate = moment(nextRecurrenceAt).startOf('day');

      if (moment(nextRecurrenceDate).isBefore(today)) {
        return `${this.$t('planInfo.expiredOn')}: ${formattedDate}`;
      }
      if (this.$store.state.subscription.plan.state == 'recurring') {
        return `${this.$t('planInfo.renewsOn')}: ${formattedDate}`;
      }

      return `${this.$t('planInfo.expiresOn')}: ${formattedDate}`;
    },
    remainingSignatures() {
      if (!this.$store.state.subscription.plan.quota) {
        return 0;
      }
      return (
        this.$store.state.subscription.plan.quota.envelopes.available -
        this.$store.state.subscription.plan.quota.envelopes.consumed
      );
    },
    isOwner() {
      return this.$store.state.organizations.selected?.is_owner ?? false;
    },
  },
};
</script>
<style lang="stylus">
.btn-link-menu
  font-size: .75rem
  color: #0080a3 !important
  text-decoration: none
  padding: 0

  .plan-details-link
    color: inherit
    text-decoration: none

    &:visited, &:hover, &:active
      color: inherit
      text-decoration: none

.info-block
  display: flex
  align-items: center

.data-block.text_sender
  flex: 1
  min-width: 0

  .text
    display: inline-block
    max-width: calc(100% - 16px)
    word-wrap: break-word
    white-space: normal
    overflow-wrap: break-word
    vertical-align: middle
</style>
